import { gql } from '@apollo/client';

/**
 * Create a new loan pool. Automatically determines sync vs async creation:
 * - Small pools (≤500 loans): Created synchronously, returns UserCompanyListing
 * - Large pools (>500 loans): Creates async job, returns PoolCreationJob
 */
export const CREATE_POOL = gql`
  mutation CreatePool(
    $name: String
    $assetClass: AssetClass!
    $filters: [Filter!]
    $loanIds: [ID!]
    $originationType: OriginationType!
  ) {
    createPool(
      input: {
        name: $name
        asset_class: $assetClass
        filters: $filters
        loan_ids: $loanIds
        origination_type: $originationType
      }
    ) {
      ... on UserCompanyListing {
        __typename
        id
        name
      }
      ... on PoolCreationJob {
        __typename
        job_id
        job_type
        status
        progress_percentage
        processed_count
        estimated_count
        pool_name
        asset_class
      }
    }
  }
`;
